// import React from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   Box,
// } from "@mui/material";
// import { Warning as WarningIcon } from "@mui/icons-material";

// const DeleteConfirmationDialog = ({
//   open,
//   onClose,
//   onConfirm,
//   title,
//   content,
// }) => {
//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle
//         sx={{
//           bgcolor: "error.main",
//           color: "white",
//           display: "flex",
//           alignItems: "center",
//           gap: 1,
//         }}
//       >
//         <WarningIcon />
//         {title || "Confirmation de suppression"}
//       </DialogTitle>
//       <DialogContent sx={{ mt: 2 }}>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
//           <Typography>
//             {content ||
//               "Êtes-vous sûr de vouloir supprimer cet élément et toutes les tranches associées ? Cette action est irréversible."}
//           </Typography>
//         </Box>
//       </DialogContent>
//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={onClose} variant="outlined">
//           Annuler
//         </Button>
//         <Button onClick={onConfirm} variant="contained" color="error" autoFocus>
//           Supprimer
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default DeleteConfirmationDialog;
import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Confirmer la suppression",
  content = "Êtes-vous sûr de vouloir supprimer cet élément ? Cette action ne peut pas être annulée.",
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="primary" variant="outlined">
          Annuler
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" autoFocus>
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
